import React, { useRef } from 'react';
import { getFileConfig } from '../../config/appConfig';

const FileUploadArea = ({ 
  dragOver, 
  onDragOver, 
  onDragLeave, 
  onDrop, 
  onFileSelect 
}) => {
  const fileInputRef = useRef(null);
  const zipInputRef = useRef(null);

  const handleGeneralFileSelect = (event) => {
    onFileSelect(event);
    // Resetear el input para permitir seleccionar los mismos archivos nuevamente
    if (event.target) {
      event.target.value = '';
    }
  };

  const handleZipFileSelect = (event) => {
    onFileSelect(event);
    // Resetear el input para permitir seleccionar los mismos archivos nuevamente
    if (event.target) {
      event.target.value = '';
    }
  };

  return (
    <div 
      className={`border-2 border-dashed rounded-3 p-4 text-center drag-drop-area ${
        dragOver 
          ? 'border-success bg-success bg-opacity-20 text-white shadow-lg drag-over-effect' 
          : 'border-primary bg-primary bg-opacity-15 text-white'
      }`}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className="mb-3">
        <i className={`fs-1 drag-drop-icon ${dragOver ? 'bi-cloud-check text-white' : 'bi-cloud-upload text-white'}`}></i>
      </div>
      <h6 className="mb-2 text-white fw-bold drag-drop-text">
        {dragOver ? '¡Suelta los archivos aquí!' : 'Arrastra y suelta tus archivos aquí'}
      </h6>
      <p className="text-white-50 mb-4 small drag-drop-text">o haz clic para seleccionar archivos</p>
      
      <div className="d-flex gap-2 justify-content-center mb-4">
        <input
          ref={fileInputRef}
          type="file"
          id="fileInput"
          className="d-none"
          multiple
          accept=".pdf,.png,.jpg,.jpeg,.zip"
          onChange={handleGeneralFileSelect}
        />
        <button 
          className="btn btn-light btn-sm shadow-sm"
          onClick={() => fileInputRef.current?.click()}
        >
          <i className="bi bi-folder2-open me-1"></i>
          Seleccionar Archivos
        </button>
        <input
          ref={zipInputRef}
          type="file"
          id="zipInput"
          className="d-none"
          accept=".zip"
          onChange={handleZipFileSelect}
        />
      </div>
      
      <div className="text-white-50 drag-drop-text" style={{ fontSize: '0.75rem' }}>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <span><i className="bi bi-file-pdf me-1"></i>PDF</span>
          <span><i className="bi bi-image me-1"></i>PNG, JPG</span>
          <span><i className="bi bi-file-zip me-1"></i>ZIP</span>
        </div>
        <div className="d-flex justify-content-center gap-3 flex-wrap mt-1">
          <span><i className="bi bi-hdd me-1"></i>Máx. {getFileConfig().MAX_SIZE_MB}MB (archivos)</span>
          <span><i className="bi bi-archive me-1"></i>Máx. {getFileConfig().MAX_SIZE_ZIP_MB}MB (ZIP)</span>
        </div>
        <p className="mb-0 mt-2">Hasta {getFileConfig().MAX_FILES} archivos a la vez</p>
      </div>
    </div>
  );
};

export default FileUploadArea;
